<template>
  <div v-if="scoutCharts.length > 0" class="scout-separately">
    <individual-scout-chart
      v-for="(scoutChart, index) in scoutCharts"
      :key="index"
      :scout-chart="scoutChart"
      :together="together"
      :e-chart-id="'scout-chart-' + index"
      :e-chart-mini-id="'scout-chart-mini-' + index"
      :input-download-file-name="inputDownloadFileName"
    />
  </div>
  <div v-else class="scout-empty">No individuals were selected.</div>
</template>

<script>
import IndividualScoutChart from "./IndividualScoutChart.vue";

export default {
  name: "ScoutSeparatelyChart",
  components: { IndividualScoutChart },
  props: {
    chartData: { type: Array, default: () => [] },
    together: { type: Boolean, default: false },
    inputDownloadFileName: { type: String, default: "Scout" }
  },
  computed: {
    scoutCharts() {
      const otherData = this.chartData && this.chartData[0] ? this.chartData[0].otherData : null;
      return otherData && Array.isArray(otherData.chartData) ? otherData.chartData : [];
    }
  }
};
</script>

<style scoped>
.scout-empty { padding: 20px; text-align: center; }
.scout-separately {width: 900px;}
</style>
